import protocoloGuard from './protocoloGuard';

const guards = [
  protocoloGuard,
];

export function applyGuards(router, store) {
  guards.forEach(guard => {
    router.beforeEach(guard(store));
  });
}
